import { InjectionFeature } from '@/common/reward/types';

export enum StarterPackRewardType {
    AvatarBundle = 1,
    AvatarBackground = 2,
    QuestBoost = 3,
    GoldenScratchTicket = 4,
    SilverScratchTicket = 5,
    WeekdayArenaTicket = 6,
    WeekendArenaTicket = 7,
    NoAds = 8
}

export class StarterPackRewardItem {
    constructor(
        public type: StarterPackRewardType | number = 0,
        public feature: InjectionFeature | number = 0,
        public itemId: number = 0,
        public itemName: string = ''
    ) {}
}

export interface StarterPackRewardDetail {
    type: StarterPackRewardType | number;
    data: number;
    quantity: number;
    itemName?: string;
    itemLink?: string;
}

export const StarterPackFeatureMapping: ReadonlyMap<StarterPackRewardType, InjectionFeature> = new Map([
    [StarterPackRewardType.AvatarBundle, InjectionFeature.AvatarBundle],
    [StarterPackRewardType.AvatarBackground, InjectionFeature.AvatarBackground],
    [StarterPackRewardType.QuestBoost, InjectionFeature.QuestBoost],
    [StarterPackRewardType.GoldenScratchTicket, InjectionFeature.ScratchTicket],
    [StarterPackRewardType.SilverScratchTicket, InjectionFeature.ScratchTicket],
    [StarterPackRewardType.WeekdayArenaTicket, InjectionFeature.ArenaTicket],
    [StarterPackRewardType.WeekendArenaTicket, InjectionFeature.ArenaTicket],
    [StarterPackRewardType.NoAds, InjectionFeature.Unknown]
]);

export const StarterPackRewardOptions = [
    {
        value: StarterPackRewardType.AvatarBundle,
        label: 'AvatarBundle'
    },
    {
        value: StarterPackRewardType.AvatarBackground,
        label: 'AvatarBackground'
    },
    { value: StarterPackRewardType.QuestBoost, feature: InjectionFeature.QuestBoost, label: 'QuestBoost' },
    {
        value: StarterPackRewardType.GoldenScratchTicket,
        label: 'GoldenScratchTicket'
    },
    {
        value: StarterPackRewardType.SilverScratchTicket,
        label: 'SilverScratchTicket'
    },
    {
        value: StarterPackRewardType.WeekdayArenaTicket,
        label: 'WeekdayArenaTicket'
    },
    {
        value: StarterPackRewardType.WeekendArenaTicket,
        label: 'WeekendArenaTicket'
    },
    {
        value: StarterPackRewardType.NoAds,
        label: 'NoAds'
    }
];
